var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"d-flex"},'div',_vm.attrs,false),[_c('div',{staticClass:"cont-dato ml-1 text-center"},[_c('h2',{class:[!!_vm.attrs?.bWidgetGrafica ? 'text-grafica' : '', 'titledata--text', 'text-medium', '']},[_vm._v(" "+_vm._s(_vm.aData[1][0] || 0)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }